import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Event, Phase, StartUp } from '../../types';
import { DateTime } from 'luxon';
import EventTimeLineCard from './EventTimeLineCard';
import { ScrollView } from 'react-native';
import TimeLineArrow from '../icons/TimeLineArrow';
import { isMobile } from '../../util/IsMobile';
import { Duration } from 'luxon';
import { sortEventsByIndex } from '../../util/SortList';


export type TimelineInProgressProps = {
    startup: StartUp,
    events?: Event[],
    highlightDuration?: Duration,
    phase: Phase
}

const TimelineInProgress: React.FC<TimelineInProgressProps> = ({ startup, events, highlightDuration, phase }) => {

    const [current, setCurrent] = useState<Event | undefined>()
    const [last, setLast] = useState<Event | undefined>()
    const [next, setNext] = useState<Event | undefined>()

    const scrollView = useRef<ScrollView>(null)

    useLayoutEffect(() => {
        if (isMobile()) {
            scrollView.current?.scrollTo({ x: 0, y: 650, animated: true })
        }
    })

    useEffect(() => {
        if (events) { setNextCurrentLastEvent(events) }

    }, [events])


    const setNextCurrentLastEvent = (events: Event[]) => {
        const ordered = sortEventsByIndex(events)
        setLast(ordered.slice().reverse().find(e => e.endDate !== undefined))
        const current_candidate = ordered.find(e => e.endDate === undefined)
        if (current_candidate?.startDate && current_candidate.startDate < DateTime.now().endOf('day')) {
            if (current_candidate.expectedNextUpdateDate && current_candidate.expectedNextUpdateDate > DateTime.now().endOf('day')) {
                setCurrent(undefined)
                setNext(current_candidate)
            } else {
                setCurrent(current_candidate)
                setNext(ordered.find(e => e.endDate === undefined && e !== current_candidate))
            }
        } else {
            setCurrent(undefined)
            setNext(current_candidate)
        }
    }

    return (
        <div style={{ overflowX: 'scroll', display: 'flex', flexDirection: 'row' }}>
            <ScrollView
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ flexGrow: 1 }}
                horizontal={true}
                centerContent
                ref={scrollView}
                contentOffset={{ x: 500, y: 0 }}
            >
                <div>
                    {last
                        ? <div style={{ overflowX: 'scroll', display: 'flex', flexDirection: 'row' }}>
                            <div>
                                <EventTimeLineCard event={last} startup={startup} lastCompleted={true} highlightDuration={highlightDuration} />
                            </div>
                            {<TimeLineArrow currentEvent={last} nextEvent={current} />}
                        </div>
                        : <div style={{ width: 360 }} />
                    }
                </div>
                <div>
                    {current
                        ? <div style={{ overflowX: 'scroll', display: 'flex', flexDirection: 'row' }}>
                            <div>
                                <EventTimeLineCard event={current} startup={startup} lastCompleted={false} highlightDuration={highlightDuration} size={'large'} />
                            </div>
                            {next && <TimeLineArrow currentEvent={current} nextEvent={next} />}
                        </div>
                        : <>
                            {last && next && <div style={{ width: 460, alignContent: 'center' }} ><TimeLineArrow currentEvent={current} nextEvent={next} /></div>}
                            {last && !next && <div style={{ width: 460 }} />}
                            {!last && next && <div style={{ width: 460 }} />}
                            {!last && !next && <div style={{ width: 460 }} />}

                        </>
                    }
                </div>
                <div>
                    {next && phase !== 'archived'
                        ? <div style={{ overflowX: 'scroll', display: 'flex', flexDirection: 'row' }}>
                            <div>
                                <EventTimeLineCard event={next} startup={startup} lastCompleted={false} highlightDuration={highlightDuration} />
                            </div>
                        </div>
                        : <div style={{ width: 360 }} />
                    }
                </div>
            </ScrollView>
        </div>
    )
}

export default TimelineInProgress